export default {
  SET_CHAT_SESSION(state, chatSession) {
    state.chatSession = chatSession;
  },
  SET_MESSAGE(state, message) {
    state.messages.push(message);
  },
};
